import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import {
  defaultSubscriptionCardData,
  ManageSubscriptionsService,
  SubscriptionCardData,
} from '../utils/manage-subscriptions.service';

@Component({
  templateUrl: './manage-subscriptions.component.html',
  styleUrls: ['./manage-subscriptions.component.scss'],
})
export class ManageSubscriptionsComponent implements OnInit {
  cards$: Observable<SubscriptionCardData[]>;
  defaultSubscriptionCardData = defaultSubscriptionCardData;

  constructor(
    private readonly manageSubscriptionsService: ManageSubscriptionsService,
    private readonly router: Router,
  ) {}

  ngOnInit(): void {
    this.cards$ = this.manageSubscriptionsService.cardData$;
  }

  comparePlans(): void {
    this.router.navigateByUrl('upgrade-subscription-tier');
  }
}
